import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledInput, InputWrapper, StyledLabel } from './styles';

const Checkbox = forwardRef(
  ({ error, label, name, id, reversed, ...rest }, ref) => (
    <InputWrapper>
      <StyledInput
        type="checkbox"
        name={name}
        id={id || name}
        ref={ref}
        data-input-scroll-id={name}
        {...rest}
      />
      <StyledLabel htmlFor={id || name} $reverseOrder={reversed}>
        {!reversed && <span />}
        {label}
        {reversed && <span />}
      </StyledLabel>
    </InputWrapper>
  )
);

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  error: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  reversed: PropTypes.bool,
};

export default Checkbox;
